
export function hasRole( user, role ) {
	//console.log( "User " + user.username + " has role? " + role );
	return user.roles.includes( role );
}
